import "./style.css";

export default class Featured {
  static selector = ".featured";

  constructor(block) {
    this.block = block;
  }
}
